module.exports = __webpack_public_path__ + "img/11.4d6fc834.png";